import React, { FC } from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { OffersBenefitCardsProps } from './OffersBenefitCards.types';
import { OffersBenefitCardsWrapper } from './OffersBenefitCardWrapper';

export const OffersBenefitCardsConfig = {
  emptyLabel: 'Offers Benefit Cards',
  isEmpty: () => true,
  resourceType: `mi-aem-offers-spa/components/offersbenefitcards`,
};

export const OfferBenefitswWrapper: React.FC<OffersBenefitCardsProps> = props => {
  return <OffersBenefitCardsWrapper {...props} />;
};

// Use named rather than default exports.
export const OffersBenefitCards: FC<OffersBenefitCardsProps> = props => {
  const isNonEditable = props.cqPath?.includes('experiencefragment');
  const offersBenefitCardsWrapper = <OfferBenefitswWrapper {...props} />;

  return isNonEditable ? (
    offersBenefitCardsWrapper
  ) : (
    <EditableComponent config={OffersBenefitCardsConfig} {...props}>
      {offersBenefitCardsWrapper}
    </EditableComponent>
  );
};
